module.exports = __webpack_public_path__ + "static/media/farmer-action-del analytics results.b85f111f.csv";